import { useState, useEffect } from "react";

const useSummaryAndFeedback = (transcript, setIsAISpeaking) => {
  const [chatFeedback, setChatFeedback] = useState({
    summary: "",
    feedback: "",
    score: null,
  });

  const userId = localStorage.getItem("userId");

  const generateSummaryAndFeedback = async () => {
    if (!transcript || transcript.length === 0) return;

    try {
      const response = await fetch( `${process.env.REACT_APP_BACKEND_URL}/generate-summary`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ transcript, userId }),
      });

      const data = await response.json();
      setChatFeedback({
        summary: data.summary,
        feedback: data.feedback,
        score: data.score,
        user_id: data.user_id,
      });

      return data;
    } catch (error) {
      console.error("Error generating summary and feedback:", error);
      return null;
    }
  };

  return { chatFeedback, generateSummaryAndFeedback };
};

export default useSummaryAndFeedback;
